<footer class="footer mt-5">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
          <div class="footer-logo">
            <img src="assets/logo/logo-malek.svg" alt="Malek Distribution Logo" height="60">
          </div>
          <p class="footer-subheading">Vape & Smoke Shop Supplier</p>
        </div>
        <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
          <h6 class="footer-section-title">Address</h6>
          <p class="footer-text">779 Lakeside Dr, Mobile, AL, 36693</p>
        </div>
        <div class="col-md-6 col-lg-4">
          <h6 class="footer-section-title">Contact</h6>
          <p class="footer-text">
            <strong>Email:</strong> <a href="mailto:malekorder@yahoo.com">malekorder@yahoo.com</a><br>
            <strong>Phone:</strong> <a href="tel:+12516076542">+1 251 607-6542</a><br>
            <strong>Cell / WhatsApp:</strong> <a href="https://wa.me/12519016034">+1 251 901-6034</a>
          </p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 text-center">
          <p class="footer-copyright">&copy; {{currentYear}} Malek Distribution. All rights reserved.</p>
        </div>
      </div>
    </div>
  </footer>